"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("stremio/core");
var common_1 = require("stremio/common");
var useRouteFocused_1 = require("stremio/common/useRouteFocused");
var EPG_1 = require("stremio/common/EPG");
var MODEL = 'live_tv_guide';
var toChannel = function (_a, deepLinks) {
    var _b;
    var id = _a.id, type = _a.type, name = _a.name, logo = _a.logo, poster = _a.poster;
    return ({
        id: id,
        type: type,
        name: name,
        logo: (_b = logo !== null && logo !== void 0 ? logo : poster) !== null && _b !== void 0 ? _b : null,
        deepLinks: deepLinks,
    });
};
var useLiveTvGuide = function (discover, epgDate, enabled) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var core = (0, core_1.useCore)();
    var routeActive = (0, useRouteFocused_1.useRouteActive)();
    var active = enabled && routeActive;
    var now = (0, EPG_1.useLiveRefresh)('LiveTvGuide', MODEL, active);
    var followedDate = epgDate !== null && epgDate !== void 0 ? epgDate : (0, EPG_1.epgDateKey)(new Date(now));
    var day = (0, react_1.useMemo)(function () {
        var _a;
        var _b = (0, EPG_1.epgDayWindow)((_a = (0, EPG_1.parseEpgDate)(followedDate)) !== null && _a !== void 0 ? _a : new Date()), start = _b.start, end = _b.end;
        return { start: new Date(start).toISOString(), end: new Date(end).toISOString() };
    }, [followedDate]);
    var request = (_b = (_a = discover.selected) === null || _a === void 0 ? void 0 : _a.request) !== null && _b !== void 0 ? _b : null;
    var state = (0, common_1.useModelState)({ model: MODEL, action: null });
    (0, react_1.useEffect)(function () {
        if (!active || request === null)
            return;
        core.transport.dispatch({
            action: 'Load',
            args: {
                model: 'LiveTvGuide',
                args: {
                    request: request,
                    date: followedDate,
                    day: day,
                    utcOffset: -new Date().getTimezoneOffset(),
                },
            },
        }, MODEL);
    }, [active, request, followedDate, day, core.transport]);
    (0, react_1.useEffect)(function () {
        if (!enabled)
            core.transport.dispatch({ action: 'Unload' }, MODEL);
    }, [enabled, core.transport]);
    var channels = (0, react_1.useMemo)(function () {
        var _a;
        return ((_a = state === null || state === void 0 ? void 0 : state.channels) !== null && _a !== void 0 ? _a : []).map(function (_a) {
            var channel = _a.channel, deepLinks = _a.deepLinks;
            return toChannel(channel, deepLinks);
        });
    }, [state === null || state === void 0 ? void 0 : state.channels]);
    var programs = (0, react_1.useMemo)(function () {
        var _a;
        return ((_a = state === null || state === void 0 ? void 0 : state.channels) !== null && _a !== void 0 ? _a : []).reduce(function (result, _a) {
            var channel = _a.channel, shows = _a.shows;
            var epgChannel = toChannel(channel);
            result[channel.id] = shows
                .map(function (show) { return (0, EPG_1.toEpgProgram)(show, epgChannel); })
                .filter(function (program) { return program !== null; });
            return result;
        }, {});
    }, [state === null || state === void 0 ? void 0 : state.channels]);
    var catalog = (_c = state === null || state === void 0 ? void 0 : state.catalog) !== null && _c !== void 0 ? _c : [];
    var errorPage = catalog.find(function (page) { return page.type === 'Err'; });
    var loadNextPage = (0, react_1.useCallback)(function () {
        core.transport.dispatch({ action: 'LiveTvGuide', args: { action: 'LoadNextPage' } }, MODEL);
    }, [core.transport]);
    var onRetry = (0, react_1.useCallback)(function () {
        core.transport.dispatch({ action: 'LiveTvGuide', args: { action: 'Retry' } }, MODEL);
    }, [core.transport]);
    return {
        now: now,
        channels: channels,
        programs: programs,
        loading: catalog.length === 0 || catalog.some(function (page) { return page.type === 'Loading'; }),
        error: errorPage === undefined ? null : typeof errorPage.content === 'string' ? errorPage.content : errorPage.content.content.message,
        hasNextPage: ((_e = (_d = state === null || state === void 0 ? void 0 : state.selectable) === null || _d === void 0 ? void 0 : _d.nextPage) !== null && _e !== void 0 ? _e : null) !== null,
        loadNextPage: loadNextPage,
        onRetry: onRetry,
        selectedDate: (_g = (_f = state === null || state === void 0 ? void 0 : state.selected) === null || _f === void 0 ? void 0 : _f.date) !== null && _g !== void 0 ? _g : epgDate,
        today: (_j = (_h = state === null || state === void 0 ? void 0 : state.selectable) === null || _h === void 0 ? void 0 : _h.today) !== null && _j !== void 0 ? _j : null,
        dayWindow: (_l = (_k = state === null || state === void 0 ? void 0 : state.selected) === null || _k === void 0 ? void 0 : _k.day) !== null && _l !== void 0 ? _l : null,
    };
};
exports.default = useLiveTvGuide;
